
export function flagContent(contentString: string): void {
    const event = new CustomEvent('xFrame:flagContent', {
        cancelable: true,
        detail: contentString,
    });
    window.dispatchEvent(event);
}